import { render, staticRenderFns } from "./ReplacedTasks.vue?vue&type=template&id=c8567dac&scoped=true"
import script from "./ReplacedTasks.vue?vue&type=script&lang=js"
export * from "./ReplacedTasks.vue?vue&type=script&lang=js"
import style0 from "./ReplacedTasks.vue?vue&type=style&index=0&id=c8567dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8567dac",
  null
  
)

export default component.exports